import { render, staticRenderFns } from "./ShowCompanyCRM.vue?vue&type=template&id=e8d9e552&scoped=true"
import script from "./ShowCompanyCRM.vue?vue&type=script&lang=js"
export * from "./ShowCompanyCRM.vue?vue&type=script&lang=js"
import style0 from "./show-company-crm.scss?vue&type=style&index=0&id=e8d9e552&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d9e552",
  null
  
)

export default component.exports